import React, { useState } from 'react';
import { blogApi } from '../../services/api';
import logger from '../../utils/logger';

function Rowcmnt({ blogId, onNewComment }) {
    const [form, setForm] = useState({
        name: '',
        email: '',
        phone: '',
        website: '',
        comment: '',
    });
    const [error, setError] = useState('');
    const [submitting, setSubmitting] = useState(false);
    const [success, setSuccess] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setSuccess(false);

        if (!form.name) {
            setError('Numele este obligatoriu.');
            return;
        }
        if (!form.email) {
            setError('Emailul este obligatoriu.');
            return;
        }
        if (!form.comment) {
            setError('Mesajul este obligatoriu.');
            return;
        }

        setSubmitting(true);

        try {
            const newComment = await blogApi.addBlogPostComment({
                blogpost_id: blogId,
                author_name: form.name.trim(),
                author_email: form.email.trim(),
                text: form.comment.trim(),
                reply_to: null,
            });

            if (onNewComment) {
                onNewComment(newComment);
            }
            
            setForm({ name: '', email: '', phone: '', website: '', comment: '' });
            setSuccess(true);
            setTimeout(() => setSuccess(false), 5000);
        } catch (err) {
            logger.error('Failed to submit comment', err);
            setError(err.message || 'Nu s-a putut trimite comentariul. Te rugăm să încerci din nou.');
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <section className="row_am comment_form_section" data-aos="fade-up" data-aos-duration={1500}>
            <div className="container container-sm">
                <div className="section_title">
                    <h2>Lasă un comentariu</h2>
                    <p>Adresa ta de email nu va fi afișată public</p>
                </div>
                {error && <div style={{ color: 'red', marginBottom: '15px', padding: '10px', background: '#ffe6e6', borderRadius: '5px' }}>{error}</div>}
                {success && <div style={{ color: 'green', marginBottom: '15px', padding: '10px', background: '#e6ffe6', borderRadius: '5px' }}>Comentariul a fost trimis cu succes!</div>}
                <form onSubmit={handleSubmit}>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Nume *"
                                    value={form.name}
                                    onChange={e => setForm({ ...form, name: e.target.value })}
                                />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <input
                                    type="email"
                                    className="form-control"
                                    placeholder="Email *"
                                    value={form.email}
                                    onChange={e => setForm({ ...form, email: e.target.value })}
                                />
                            </div>
                        </div>
                        <div className="col-md-12">
                            <div className="form-group">
                                <textarea
                                    className="form-control"
                                    placeholder="Comentariu *"
                                    value={form.comment}
                                    onChange={e => setForm({ ...form, comment: e.target.value })}
                                />
                            </div>
                        </div>
                        <div className="col-md-12 text-right">
                            <div className="btn_block">
                                <button className="btn puprple_btn ml-0" disabled={submitting}>
                                    {submitting ? 'Se trimite...' : 'Trimite'}
                                </button>
                                <div className="btn_bottom" />
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </section>
    );
}

export default Rowcmnt;
